import gql from 'graphql-tag';
import {
    LISTING_ANALYTICS_ECOMMERCE,
    LISTING_ANALYTICS_TAXONOMY
} from 'listing-details/queries/pageTracking.queries';

export const LISTING_CONTACT_TAXONOMY = gql`
    fragment LISTING_CONTACT_TAXONOMY on ListingData {
        listingUris {
            contact
        }
        analyticsEcommerce {
            ...LISTING_ANALYTICS_ECOMMERCE
        }
        analyticsTaxonomy {
            ...LISTING_ANALYTICS_TAXONOMY
        }
    }
    ${LISTING_ANALYTICS_ECOMMERCE}
    ${LISTING_ANALYTICS_TAXONOMY}
`;
